import React from 'react';
import { useAssistantContext } from './Provider';
import { useRef, useEffect } from 'react';
import { classNames, isLocal } from '../../Services/helpers';
import Icon from '../Icons/Icon';
import Dropdown from '../Dropdown';
import Form, { Assets } from '../Form';
import Loading from '../Loading';
import { useKeyboardHelper } from '../Mobile';

const ReplyBox = () => {
    const {
        conversation, dictationAvailable, tmpQuestion, setTmpQuestion, dictating, toggleDictation,
        showAssets, setShowAssets, assetIds, setAssetIds,
        submitMessage, isLoading, newConversation, requestHumanAttention, nudgeAssistant
    } = useAssistantContext();
    const {hideNav, showNav} = useKeyboardHelper('assistant-replybox');
    const inputRef = useRef(null);

    useEffect(() => {
        if (!inputRef?.current) {
            return;
        }
        inputRef.current.style.height = '1px';
        inputRef.current.style.height = `max(1.5rem, ${inputRef.current.scrollHeight}px)`;
    }, [tmpQuestion])

    const submit = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!tmpQuestion) {
            return;
        }
        submitMessage(tmpQuestion);
        setTmpQuestion('');
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (e.shiftKey || e.altKey) {
                // Allow new line
                return;
            } else {
                e.preventDefault();
                submit(e);
            }
        }
    }
    return <div className="w-full flex flex-row items-center">
        <Dropdown
            className="text-slate-900 fill-slate-900 dark:text-slate-100 dark:fill-slate-100"
            options={[
                {
                    title: 'New conversation',
                    icon: 'RotateRight',
                    onClick: () => newConversation(),
                },
                {
                    title: 'Nudge Sid',
                    icon: 'HandBackPointRight',
                    onClick: () => nudgeAssistant(),
                },
                {
                    title: 'Human attention',
                    icon: 'Hand',
                    onClick: () => requestHumanAttention(),
                },
                {
                    title: 'Attach file',
                    icon: 'Paperclip',
                    onClick: () => setShowAssets(!showAssets),
                },
            ]}
            openUp
            openRight
            flush
        />

        <div className={classNames(
            'grow bg-white dark:bg-black',
            'flex flex-col',
            'm-2 ml-0 border border-slate-200 dark:border-slate-700 rounded-lg',
            dictating ? 'ring-2 ring-red-600 fill-red-600' : 'focus-within:ring-2 ring-brand',
        )}>
            <div className="flex justify-between items-top">
                {dictationAvailable && <div className={classNames(
                        'w-8 h-8 shrink-0 grow-0 rounded-full mr-1 flex justify-center items-center',
                        'hover:fill-red-600 cursor-pointer',
                        dictating ? 'fill-red-600' : 'fill-muted',
                    )} onClick={toggleDictation}>
                        <Icon icon="Microphone" theme={dictating ? 'solid' : 'light'} />
                </div>}

                <form onSubmit={submit} className="contents">
                    <textarea
                        ref={inputRef}
                        // placeholder="Ask me anything!"
                        placeholder={
                            assetIds?.length > 0 ? 'Add a message to send attachments' : 'Ask me anything!'
                        }
                        value={tmpQuestion}
                        onChange={e => setTmpQuestion(e.target.value)}
                        onKeyDown={handleKeyDown}
                        onFocus={hideNav}
                        onBlur={showNav}
                        className="grow p-1 border-none focus:outline-hidden focus:ring-0 text-sm text-slate-900 dark:text-slate-100 rounded-lg text-wrap overflow-none resize-none dark:bg-black disabled:bg-slate-100 dark:disabled:text-gray-500"
                    />
                </form>
                {isLoading && <Loading className="m-2" />}
                {!isLoading && <Icon
                    theme="solid"
                    // theme={assetIds?.length > 0 ? 'light' : 'solid'}
                    icon={assetIds?.length > 0 ? 'Paperclip' : 'CircleArrowRight'}
                    className={classNames('m-2', (tmpQuestion || assetIds?.length > 0) ? 'fill-brand' : 'fill-muted')}
                    onClick={submit}
                />}
            </div>

            <div className={classNames('p-2', showAssets ? 'block' : 'hidden')}>
                {(conversation && showAssets) && <Form data={{assetIds}}>
                    <Assets name="assetIds"
                        tags={[{name: 'conversation', value: conversation.id}]}
                        onChange={val => setAssetIds(val)}
                        accept="*/*"
                        // help={assetIds?.length > 0 ? "Don't forget to send your files!" : "Sid can't see your files, but his humans can."}
                        help="Sid can't see your files, but his humans can."
                        focusRing={false}
                        showPrevious={isLocal()}
                    />
                </Form>}
            </div>
        </div>
    </div>
}

export default ReplyBox;
